import { ajax as request } from '@blade/common';
export const GethistorySummary = (data) => request({
    url: '/api/crowd-record-management/api/v1/queue/aggregate/historySummary',
    method: 'POST',
    data
});
export const GethistoryPass = (data) => request({
    url: '/api/crowd-record-management/api/v1/queue/aggregate/historyPassCountInfo',
    method: 'POST',
    data
});
export const GethistoryPassTime = (data) => request({
    url: '/api/crowd-record-management/api/v1/queue/aggregate/historyPassTimeInfo',
    method: 'POST',
    data
});
export const getTypes = (taskType) => request({
    url: `/api/task-management/api/v1/sc/task/device/infos/type/${taskType}`,
    method: 'GET',
});
